import {
  Container,
  Row,
  Col,
} from 'react-bootstrap';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime)

function TXItem(key, tx, executed) {
  const currentTime = dayjs();
  const txTime = dayjs.unix(tx.timeStamp);

  function appendComma(text, index, length) {
    if (index < length - 1) {
      return text + ", "
    } else {
      return text
    }
  }

  function parseForAddr(dataItem, prevItemAddr) {
    if (dataItem.startsWith("0x") && dataItem.length == 42) {
      return [<a target='_blank' href={`https://etherscan.io/address/${dataItem}`}>
        {dataItem}
      </a>, true]
    } else {//(prevItemAddr ? ", " : "") 
      return [<a>{", " + appendComma(dataItem)}</a>, false]
    }
  }

  function formatDisplay(txData) {
    console.log(txData)
    if (!txData) {
      return "";
    }
    const splitObjs = String(txData).split(", ");
    let prevItemAddr = false;
    const dispObjs = splitObjs.reduce((acc, dataItem, index) => {
      return acc.concat(dataItem.split(",").map(nestedData => {
        const result = parseForAddr(nestedData, prevItemAddr)
        prevItemAddr = result[1]
        return result[0]
      }))
    }, []);
    return dispObjs;
  }

  // TODO handle tx.data here to properly do hyperlinks.
  return (
    <Container key={key} style={{ paddingTop: 16, width: "100%" }}>
      <Row style={{ alignItems: "center" }}>
        <Col xs={2}>
          <a target='_blank' href={`https://etherscan.io/tx/${tx.hash}`}>Transaction</a>
          <br />
          {txTime.from(currentTime)}
        </Col>
        <Col xs={8}>
          <Row style={{ paddingBottom: 8 }}>{tx.functionCall}</Row>
          <Row>{formatDisplay(tx.data)}</Row>
        </Col>
      </Row>
    </Container>
  );
}

export default TXItem;
